import { FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../components/Header';
import colors from '../styles/colors';
import useResponsiveRedux from '../components/Hooks/useResponsiveRedux';
import MobileFooter from '../components/MobileComponents/MobileFooter';

const BodyContainer = styled.div`
  background: ${colors.bgGradientSfondoColor};
  min-height: 100vh;
  font-family: CameronSansMedium, CameronSansLight, Trebuchet MS, Arial, Helvetica, Verdana,
    Tahoma, sans-serif;
  color: white;

  & img {
    object-position: top;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    padding-top: 70px;
    box-sizing: border-box;
  }
`;

const RootLayout: FC = () => {
  const { isMobile } = useResponsiveRedux();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <BodyContainer>
      <Header />
      <Outlet />
      {isMobile && <MobileFooter />}
    </BodyContainer>
  );
};

export default RootLayout;
